import styled from "styled-components";

export const SearchDropdown = styled.div`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  transition:
    grid-template-rows 350ms ease,
    opacity 250ms ease;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  overflow: hidden;
`;

export const SearchDropdownInner = styled.div`
  min-height: 0;
  max-height: 16rem;
  overflow-y: auto;
`;

export const SectionContent = styled.div`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  transition: grid-template-rows 300ms ease;
`;

export const SectionContentInner = styled.div`
  min-height: 0;
  overflow: hidden;
`;
